import { useMemo } from 'react';

import { DefaultFormFieldLayout } from '@bambi/component-library/src/components/forms/DefaultFormFieldLayout/DefaultFormFieldLayout';
import { Select } from '@bambi/component-library/src/components/inputs/Select/Select';

import { transportTypeOptions } from 'src/features/add-trip/ServiceDetails/transportTypeOptions';

import {
  FormFieldController,
  FormFieldControllerRulesProps,
} from './FormField/FormFieldController';
import { MultiSelectContextField } from './FormField/MultiSelectContextField';

import type { HelperText } from '@bambi/component-library/src/components/forms/FormFieldHelperText/FormFieldHelperText';

interface SpaceTypeFieldProps {
  fieldName: string;
  label?: string;
  rules?: FormFieldControllerRulesProps;
}
export function SpaceTypeField({
  fieldName,
  label = 'Space Type',
  rules,
}: SpaceTypeFieldProps) {
  return (
    <FormFieldController name={fieldName} rules={rules}>
      {({ field, fieldState }) => {
        return (
          <DefaultFormFieldLayout
            label={label}
            inputId={fieldName}
            error={fieldState.error?.message}
          >
            <Select
              value={field.value}
              options={transportTypeOptions}
              testIdSuffix={fieldName}
              onChange={(selected) => {
                field.onChange(selected?.value);
              }}
              placeholder="Select a space type"
            />
          </DefaultFormFieldLayout>
        );
      }}
    </FormFieldController>
  );
}

export function MultiSelectSpaceTypeField({
  fieldPath,
  rules,
  inline,
  disabled,
  helperText,
}: {
  fieldPath: string;
  rules?: FormFieldControllerRulesProps;
  inline?: boolean;
  disabled?: boolean;
  helperText?: HelperText;
}) {
  const label = useMemo(() => {
    return rules?.required ? 'Space Types *' : 'Space Types';
  }, [rules?.required]);

  return (
    <div>
      <MultiSelectContextField
        options={transportTypeOptions}
        fieldPath={fieldPath}
        label={label}
        disabled={disabled}
        rules={rules}
        inline={inline}
        helperText={helperText}
      />
    </div>
  );
}
